@if (notificationDocumentSelections?.length > 0) {
  <div
    class="assets">
    <div
      class="asset-recipients"
      fxLayout="row"
      fxLayoutAlign="space-between center">
      <div
        fxLayout="row"
        fxLayoutAlign="start center">
        <topo-checkbox
          [checked]="includeAllDocuments"
          [indeterminate]="partialIncludeDocuments"
        (checkChanged)="onIncludeDocumentsChanged($event)"></topo-checkbox>
        <div
          fxLayout="row"
          fxLayoutAlign="start center">
          <div>{{ 'COMMUNICATIONS.SELECTED-ITEMS-RECIPIENTS' | translate }}</div>
          <div class="total-counter">
            {{ documentRecipientCount }}
          </div>
        </div>
      </div>
    </div>
    @for (notificationDocumentSelection of notificationDocumentSelections; track notificationDocumentSelection.documentUId; let last = $last) {
      <div>
        <div
          class="layer-group"
          [ngClass]="{ 'last-in-child': true }">
          <div
            fxLayout="row"
            fxLayoutAlign="space-between start center">
            <div
              fxLayout="row"
              fxLayoutAlign="start center">
              <div>
                <topo-checkbox
                  [checked]="notificationDocumentSelection.include"
                (checkChanged)="onDocumentSelectChanged(notificationDocumentSelection, $event)"></topo-checkbox>
              </div>
              <div
                fxLayout="row"
                fxLayoutAlign="start center">
                <div
                  class="asset-icon">
                  @if (!notificationDocumentSelection.isCustomIcon) {
                    <div
                      class="asset-icon"
                      fxLayout="row"
                      fxLayoutAlign="space-around center"
                      [style]="'background-color:' + (notificationDocumentSelection.color || '#FFFFFF') + ';color: #FFFFFF'">
                      <div
                        class="material-icons"
                        style="font-size: 16px">
                        {{ notificationDocumentSelection.iconPath }}
                      </div>
                    </div>
                  }
                  @if (!!notificationDocumentSelection.isCustomIcon) {
                    <div
                      class="asset-icon"
                      fxLayout="row"
                      fxLayoutAlign="space-around center"
                      [style]="'background-color:' + (notificationDocumentSelection.color || '#FFFFFF') + ';color: #FFFFFF'">
                      <img
                        [src]="notificationDocumentSelection.iconPath | safeUrl"
                        style="width: 16px; height: 16px; margin: 4px 0px 0px 4px" />
                    </div>
                  }
                </div>
                <div class="asset-name ml-2">
                  {{ notificationDocumentSelection.documentName }}
                </div>
                <div class="asset-count ml-1">
                  @if (!!!notificationDocumentSelection.recipientCount) {
                    <span
                      class="no-count-warning-text">
                      <i class="icon icon-small_solid_warning no-count-warning"></i>
                      {{ 'COMMUNICATIONS.NO-TOTAL-CONTACTS' | translate }}
                    </span>
                  }
                  @if (!!notificationDocumentSelection.recipientCount) {
                    <span
                      class="contact-count">
                      &nbsp; {{ 'COMMUNICATIONS.TOTAL-CONTACTS' | translate : { number: notificationDocumentSelection.recipientCount } }}
                    </span>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}
